import type { FC } from 'react';
import styled from '@emotion/styled';

import type { PricingPageShopProduct_magento2_products_items_Magento2_ConfigurableProduct_variants as MagentoProductVariant } from '../../hook/__generated__/PricingPageShopProduct';

const StyledUpgradeLink = styled.span`
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.colors?.protectedContentLinkHover};
  }
`;

const UpgradeLink: FC<{
  selectVariant: (value: MagentoProductVariant) => void;
  upgradeVariant: MagentoProductVariant;
}> = ({ selectVariant, upgradeVariant }) => {
  const handleSelectUpdate = () => selectVariant(upgradeVariant);

  return (
    <StyledUpgradeLink
      onClick={handleSelectUpdate}
      onKeyDown={handleSelectUpdate}
      // biome-ignore lint/a11y/useSemanticElements: FIX ME!
      role="link"
      tabIndex={0}
    >
      {
        upgradeVariant.attributes?.find((attr) => attr?.code === 'license_code')
          ?.label
      }
    </StyledUpgradeLink>
  );
};

export default UpgradeLink;
